import { EnergyTariffForm as EnergyTariffFormUnwrapped } from '@features/EnergyTariffForm';
import { withProfiler } from '@services/sentry/withProfiler';

const EnergyTariffForm = withProfiler(EnergyTariffFormUnwrapped);
export { EnergyTariffForm };
